import { DOCUMENT_TYPE, DocumentType } from '../constants/document-type';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

export class DocumentTypeDefinitions{
  static getMaxLength(documentType: DocumentType): number {
    switch (documentType.documentType) {
      case DOCUMENT_TYPE.CIVILID: return 10;
      case DOCUMENT_TYPE.UNIDENTIFIEDADULT: return 10;
      case DOCUMENT_TYPE.BITHCERTIFICATE: return 11;
      case DOCUMENT_TYPE.CIVILINDETITYRECORD: return 11;
      case DOCUMENT_TYPE.UNIDENTIFIEDMINOR: return 12;
      case DOCUMENT_TYPE.FOREIGNERID: return 15;
      case DOCUMENT_TYPE.TEMPORARYSTAYPERMIT: return 15;
      case DOCUMENT_TYPE.PASSPORT: return 16;
      case DOCUMENT_TYPE.BORNALIVESTATEMENT: return 16;
      case DOCUMENT_TYPE.DIPLOMATICPASSPORT: return 16;
      case DOCUMENT_TYPE.PERMANENCESAFECONDUCT: return 16;
      case DOCUMENT_TYPE.NATIONALALIENREGISTRATIOM: return 18;
      case DOCUMENT_TYPE.FOREIGNERREGISTRATIONCARD: return 30;
      default: return 10;
    }
  }

  static getLabelExpression(documentType: DocumentType): string {
    switch (documentType.documentType) {
      case DOCUMENT_TYPE.CIVILID: return MessageService.translate('account.document.label.civilid');
      case DOCUMENT_TYPE.FOREIGNERREGISTRATIONCARD: return MessageService.translate('account.document.label.foreignerregistrationcard');
      case DOCUMENT_TYPE.DIPLOMATICPASSPORT: return MessageService.translate('account.document.label.diplomaticpassport');
      case DOCUMENT_TYPE.PASSPORT: return MessageService.translate('newaccount.field.foreign.passport');
      case DOCUMENT_TYPE.PERMANENCESAFECONDUCT: return MessageService.translate('account.document.label.permanencesafeconduct');
      case DOCUMENT_TYPE.NATIONALALIENREGISTRATIOM: return MessageService.translate('account.document.label.nationalalienregistratiom');
      case DOCUMENT_TYPE.BITHCERTIFICATE: return MessageService.translate('account.document.label.bithcertificate');
      case DOCUMENT_TYPE.CIVILINDETITYRECORD: return MessageService.translate('account.document.label.civilindetityrecord');
      case DOCUMENT_TYPE.BORNALIVESTATEMENT: return MessageService.translate('account.document.label.bornalivestatement');
      case DOCUMENT_TYPE.UNIDENTIFIEDADULT: return MessageService.translate('account.document.label.unidentifiedadult');
      case DOCUMENT_TYPE.UNIDENTIFIEDMINOR: return MessageService.translate('account.document.label.unidentifiedminor');
      case DOCUMENT_TYPE.TEMPORARYSTAYPERMIT: return MessageService.translate('account.document.label.temporarystaypermit');
      case DOCUMENT_TYPE.FOREIGNERID: return MessageService.translate('account.document.label.foreignerid');
      default: return 'account.document.label.civilid';
    }
  }
}
